<template>
  <div id="container" style="margin: 20px">

    <el-row :gutter="10">

      <el-col :lg="8">

        <el-card class="box-card">

          <el-table
            ref="groupTable"
            v-loading="loadingGroup"
            :data="groupData"
            :expand-row-keys="expandKeys"
            height="650"
            style="width: 100%"
            row-key="c_id"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            highlight-current-row
            @row-dblclick="chooseGroup"

          >
            <el-table-column label="名称">
              <template slot-scope="scope">
                <span v-if="!scope.row.isEdit">{{ scope.row.c_name }}</span>
                <el-input
                  v-else
                  v-model="scope.row.c_name"
                  placeholder="请输入部门名称"
                  clearable
                  suffix-icon="el-icon-s-cooperation"
                />
              </template>
            </el-table-column>
            <el-table-column v-if="onLine" align="center">
              <template slot="header">
                <el-button
                  type="success"
                  icon="el-icon-plus"
                  circle
                  @click="addParentGroup"
                />
              </template>
              <template slot-scope="scope">
                <el-button
                  v-show="!scope.row.showMore && onLine"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  @click="showMoreBtn(scope.$index, scope.row)"
                />
                <el-button
                  v-show="
                    scope.row.c_id != '' &&
                    !scope.row.isEdit &&
                    scope.row.showMore
                  "
                  type="success"
                  size="small"
                  @click="addGroup(scope.$index, scope.row)"
                >增加</el-button
                >
                <el-button
                  v-show="
                    scope.row.c_id != '' &&
                    !scope.row.isEdit &&
                    scope.row.showMore
                  "
                  type="primary"
                  size="small"
                  @click="editGroup(scope.$index, scope.row)"
                >编辑</el-button
                >
                <el-button
                  v-show="scope.row.isEdit && scope.row.showMore"
                  type="success"
                  size="small"
                  @click="saveGroup(scope.$index, scope.row)"
                >保存</el-button
                >
                <el-button
                  v-show="
                    scope.row.c_id != '' &&
                    scope.row.isEdit &&
                    scope.row.showMore
                  "
                  type="warning"
                  size="small"
                  @click="cancelEditGroup(scope.$index, scope.row)"
                >取消编辑</el-button
                >
                <el-button
                  v-show="scope.row.showMore"
                  type="danger"
                  size="small"
                  @click="deleteGroup(scope.$index, scope.row)"
                >删除</el-button
                >
                <el-button
                  v-show="scope.row.showMore"
                  type="danger"
                  size="small"
                  icon="el-icon-back"
                  circle
                  @click="closeMoreBtn(scope.$index, scope.row)"
                />
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>

      <el-col :lg="16">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>用户(双击部门查看)</span>
          </div>


          <template>
            <el-button @click="handleClick()"
                       type="success" icon="el-icon-check"
                       size="small" circle>新增</el-button>

            <el-table
              :data="userData"
              height="520"
              border
              style="width: 100%">
              <el-table-column
                prop="c_id"
                label="编号"
                width="180">
              </el-table-column>
              <el-table-column
                prop="c_name"
                label="姓名"
                width="180">
              </el-table-column>

              <el-table-column
                prop="c_mobile"
                label="手机号码">
              </el-table-column>
              <el-table-column
                prop="c_role"
                label="角色">
                <template slot-scope="scope">
                  <p v-if="scope.row.c_role=='0'">普通用户</p>
                  <p v-if="scope.row.c_role=='1'">管理员</p>
                </template>
              </el-table-column>
              <el-table-column v-if="onLine" label="头像">
                <template slot-scope="scope">
                  <span v-if="scope.row.isEdit" />
                  <el-image
                    v-else
                    style="width: 50px; height: 50px; border-radius: 5px"
                    :src="scope.row.c_photo"
                    :preview-src-list="[scope.row.c_photo]"
                  />
                </template>
              </el-table-column>

              <el-table-column
                fixed="right"
                label="操作"
                width="160">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="editUser(scope.$index, scope.row)">编辑</el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="deleteUser(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>

            </el-table>
          </template>
        </el-card>

        <!-- 新增编辑弹框 -->
        <el-dialog
          :title="addtitle"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose"
        >
          <el-form
            :model="user"
            ref="refRuleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="姓名" prop="roleName">
              <el-input v-model="user.c_name"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="roleName">
              <el-input v-model="user.c_mobile"></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="c_role">

            <el-select v-model="user.c_role" placeholder="请选择角色">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            </el-form-item>

            <el-form-item label="密码" prop="roleName">
              <el-input placeholder="请输入密码" v-model="user.c_password" show-password></el-input>
            </el-form-item>

          </el-form>
          <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleConfirm">确 定</el-button>
      </span>
        </el-dialog>

      </el-col>
    </el-row>

  </div>
</template>
<script>
import user from "@/api/user"
import md5 from "js-md5";
export default {
  data() {
    return {
      addtitle: "",
      showSyncGroup: false,
      onLine:false,
      userData:[],
      loadingGroup:true,
      expandKeys:[],
      groupData:[],//部门值
      chooseGroupId:"",//部门id
      dialogVisible:false, //新增修改弹出框
      options:[{
        value:"0",
        label:"普通用户"
      },{
        value:"1",
        label:"管理员"
      }],
      user:{
        c_id:"",
        c_name:"",
        c_group_id:"",
        c_weixin:"",
        c_mobile:"",
        c_password:"",
        c_role:"",
        c_photo:"",
      }
    }
  },
  mounted() {
    this.onLine = true;
    this.showSyncGroup=true;
    this.getParentGroup();
    // this.getusersss();
  },
  created() {

  },
  methods: {
   // 获取一级部门
    getParentGroup() {
      user.getGroups().then((res) => {
        res = res.data;
        const data = res.data;
        this.groupData = [];
        data.forEach((element) => {
          this.groupData.push({
            c_id: element.c_id,
            c_name: element.c_name,
            p_id: element.p_id,
            children: this.getChildren(element.groupList),
            isEdit: false,
            showMore: false,
          });
        });
        this.loadingGroup = false;
      });
    },

    // 获取子部门
    getChildren(groupList) {
      const child = [];
      if (groupList != null && groupList.length != 0) {
        groupList.forEach((element) => {
          child.push({
            c_id: element.c_id,
            c_name: element.c_name,
            p_id: element.p_id,
            children: this.getChildren(element.groupList),
            isEdit: false,
            showMore: false,
          });
        });
      }
      return child;
    },

    // 保存group
    saveGroup(index, row) {
      if (row.c_name.trim() == "") {
        this.$notify.warning("请输入部门名称");
        return;
      }
      //console.log(index,row,3456)
      if (row.c_id == "") {
        user.addGroups(row).then((res) => {
          res = res.data;
          if (res.code == 200) {
            this.$notify.success(res.msg);
            this.getParentGroup();
          } else {
            this.$notify.error(res.msg);
          }
        });
      } else {
        // 编辑
        user.updateGroup(row).then((res) => {
          res = res.data;
          if (res.code == 200) {
            this.$notify.success(res.msg);
            this.getParentGroup();
          } else {
            this.$notify.error(res.msg);
          }
        });
      }
    },

    closeMoreBtn(index, row) {
      row.showMore = false;
    },

    // 添加子部门
    addGroup(index, row) {
      const res = row.children.every((e) => {
        return e.c_id != "";
      });
      if (res) {
        row.children.unshift({
          c_id: "",
          c_name: "",
          p_id: row.c_id,
          isEdit: true,
          showMore: true,
        });
      }
      this.$nextTick(() => {
        this.$refs.groupTable.toggleRowExpansion(row, true);
      });
    },
    // 编辑部门
    editGroup(index, row) {
      row.isEdit = true;
    },
    // 取消编辑
    cancelEditGroup(index, row) {
      row.isEdit = false;
    },

    // 删除部门
    deleteGroup(index, row) {
      if (row.c_id == "") {
        if (row.p_id == 0) {
          this.groupData.splice(index, 1);
        } else {
          // todo
          this.getDeleteGroupIndex(row, this.groupData);
          this.deleteGroupId.splice(0, 1);
        }
        return;
      }
      this.$confirm("确定删除该部门?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          user.deleteGroup({
            groupId: row.c_id,
          }).then((res) => {
            res = res.data;
            if (res.code == 200) {
              this.$notify.success(res.msg);
              this.getParentGroup();
            } else {
              this.$notify.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },

    getDeleteGroupIndex(row, parent) {
      if (parent.length != 0) {
        for (let i = 0; i < parent.length; i++) {
          const data = parent[i];
          if (data.c_id == row.p_id) {
            this.deleteGroupId = data.children;
          } else {
            this.getDeleteGroupIndex(row, data.children);
          }
        }
      }
      return this.deleteGroupId;
    },
    // 添加父部门
    addParentGroup() {
      const res = this.groupData.every((e) => {
        return e.c_id != "";
      });
      if (res) {
        this.groupData.unshift({
          c_id: "",
          c_name: "",
          p_id: 0,
          isEdit: true,
          showMore: true,
        });
      }
    },

    chooseGroup(row) {
      this.chooseGroupId = row.c_id;
      this.getUserByGroupId(this.chooseGroupId);
    },
    // 获取部门用户
    getUserByGroupId() {
      user.getUserByGroupId({ groupId: this.chooseGroupId }).then((res) => {
        this.onLine = true;
        res = res.data;
        this.userData = res.data;
        //console.log( this.userData,res.data,45)
      });
    },

    showMoreBtn(index, row) {
      row.showMore = true;
    },

    getusersss(){
      user.getUser().then((res)=>{
        this.onLine = true,
        this.userData=res.data.data
        console.log(userData,3333)
      })
    },
    // 用户编辑
    editUser(index, row){
      this.addtitle="修改用户";
      user.userById({
        c_id :row.c_id
      }).then((res)=>{
       this.user= res.data.data;
        this.dialogVisible=true;
      })
    },
    // 取消编辑
    cancelEditUser(index, row) {
      row.isEdit = false;
    },
  // 删除用户
    deleteUser(index, row) {
      this.$confirm("确定删除该用户?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          user.deleteUsertupu({
            c_id:row.c_id,
          }).then((res) => {
            this.getUserByGroupId(this.chooseGroupId);

          });
        })
        .catch(() => {});
    },
    handleClose(){
     this.dialogVisible=false;
    },

    // 保存用户
    saveUser(index, row) {
      // 验证
      row.c_gopen_id = undefined;
      const reg = /^[0-9a-zA-Z]*$/g;
      const regPhone = /^1[3456789]\d{9}$/;
      if (!reg.test(row.c_id)) {
        this.$notify.error("编号只能为字母或数字");
        return;
      }
      if (row.c_name.trim() == "") {
        this.$notify.error("请输入名称");
        return;
      }
      if (!regPhone.test(row.c_mobile)) {
        this.$notify.error("手机号码格式不正确");
        return;
      }
      user.addtupuUser({
        c_desc:row.c_group_id,
        c_id:row.c_id,
        c_mobile:row.c_mobile,
        c_name:row.c_name,
      }).then((res)=>{
        this.getUserByGroupId(this.chooseGroupId);
          row.isEdit = false;
      })

    },
    //用户新增
    handleClick(){
      this.addtitle="添加用户";
      this.dialogVisible=true;
      this.user=[];
    },

    dialogVisibleConfirm(){
      const regPhone = /^1[3456789]\d{9}$/;
      if (this.user.c_name.trim() == "") {
        this.$notify.error("请输入名称");
        return;
      }
      if (!regPhone.test(this.user.c_mobile)) {
        this.$notify.error("手机号码格式不正确");
        return;
      }
     this.dialogVisible=false;
      if(this.user.c_id==null){
        //新增
        user.addtupuUser({
          c_role: this.user.c_role,
          c_weixin: this.user.c_weixin,
          c_password: md5(this.user.c_password),
          c_mobile:this.user.c_mobile,
          c_name:this.user.c_name,
          c_group_id: this.chooseGroupId,
        }).then((res)=>{
          if(res.data.code == 200){
            this.$notify.success("成功");
            this.getUserByGroupId(this.chooseGroupId);
          }else {
            this.$notify.error("失败");
          }
        })
      }else {
       user.updateUser({
         c_id:this.user.c_id,
         c_role: this.user.c_role,
         c_weixin: this.user.c_weixin,
         c_password: this.user.c_password==null?null:md5(this.user.c_password),
         c_mobile:this.user.c_mobile,
         c_name:this.user.c_name,
         c_group_id: this.chooseGroupId,
       }).then((res)=>{
         if(res.data.code == 200){
           this.$notify.success(res.data.msg);
           this.getUserByGroupId(this.chooseGroupId);
         }else {
           this.$notify.error("失败");
         }

       })
      }

    },

    // 添加部门用户
    addUser() {
      if (
        this.userData.every((e) => {
          return !(e.c_id == "" && e.c_name == "");
        })
      ) {
        this.userData.unshift({
          c_id: "",
          c_name: "",
          c_mobile: "",
          c_role: "",
          isEdit: true,
        });
      }
    },


  }
}
</script>
<style scoped>
.backgr {
  background-color: #ffffff;
}
.div-margin {
  margin: 10px 0px;
}
.div-table {
  max-width: 1202px;
}
.input-title {
  margin: 10px 0px;
}
.div-form-button {
  text-align: right;
  margin-top: 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/yonghu.vue